import React, { useCallback, useEffect, useState } from 'react';

import DataGrid from 'react-data-grid';

import { Tabela } from './styles';
import api from '../../../services/api';
import Button from '../../Button';

interface Vendas {
  cd_prod: number;
  nm_prod: string;
  obs: string;
  vl_unit: number;
  data_fechamento: string;
  serie: string;
  num: string;
  cd: number;
  qtd: number;
  vl_desc: number;
  subtot: number;
  total: number;
}

const defaultColumnProperties = {
  resizable: true,
};

const columnsVenda = [
  { key: 'Venda', name: 'Venda' },
  {
    key: 'Serie',
    name: 'Série',
    width: 100,
  },
  {
    key: 'Numero',
    name: 'Número',
    width: 100,
  },
  {
    key: 'Total',
    name: 'Total',
    width: 100,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));
const columnsVendasProdutos = [
  {
    key: 'CodigoProduto',
    name: 'Cd',
    width: 45,
  },
  { key: 'NomeProduto', name: 'Produto' },

  {
    key: 'Obs',
    name: 'Observação',
    width: 275,
  },
  {
    key: 'ValorUnitario',
    name: 'Vl Unit.',
    width: 90,
  },
  {
    key: 'DataFechamento',
    name: 'Fechamento',
    width: 130,
  },
  {
    key: 'Serie',
    name: 'Série',
    width: 100,
  },
  {
    key: 'Numero',
    name: 'Num',
    width: 45,
  },
  { key: 'Venda', name: 'Venda', width: 65 },
  {
    key: 'Quantidade',
    name: 'Qtd',
    width: 45,
  },
  {
    key: 'ValorDesconto',
    name: 'Desconto',
    width: 100,
  },
  {
    key: 'SubTotal',
    name: 'Sub Total',
    width: 90,
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));

const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis para as datas selecionadas...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};

interface VendaProps {
  dt_inicial: string;
  dt_final: string;
  cd_empresa: string;
}

const Vendas: React.FC<VendaProps> = ({ dt_inicial, dt_final, ...rest }) => {
  const [rowsVenda, setRowsVenda] = useState([] as any);
  const [rowsVendasProdutos, setRowsVendasProdutos] = useState([] as any);
  const [
    rowsVendasProdutosPorVendas,
    setRowsVendasPorProdutosPorVendas,
  ] = useState([] as any);
  const [vendaClicada, setVendaClicada] = useState([] as any);
  const [totalVendas, setTotalVendas] = useState('');

  const cd_empresa = sessionStorage.getItem('cd');

  useEffect(() => {
    api
      .get<Vendas[]>('reports/vendas', {
        params: {
          dt_inicial,
          dt_final,
          cd_empresa,
        },
      })
      .then((response) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        let somar = 0;
        const itemsFormatted = [] as Array<any>;
        response.data.forEach((venda) => {
          itemsFormatted.push({
            CodigoProduto: venda.cd_prod,
            // data_abertura: venda.data_abertura,
            NomeProduto: venda.nm_prod,
            Obs: venda.obs,
            ValorUnitario: formatter.format(venda.vl_unit),
            DataFechamento: venda.data_fechamento,
            Serie: venda.serie,
            Numero: venda.num,
            Venda: venda.cd,
            Quantidade: venda.qtd,
            ValorDesconto: formatter.format(venda.vl_desc),
            SubTotal: formatter.format(venda.subtot),
            Total: formatter.format(venda.total),
          });
          somar += venda.subtot;
        });
        setTotalVendas(formatter.format(somar));
        setRowsVendasProdutos(itemsFormatted);
      })
      .catch(() => {
        setRowsVendasProdutos([]);
      });
    api
      .get<Vendas[]>('reports/vendas-ficha', {
        params: {
          dt_inicial,
          dt_final,
          cd_empresa,
        },
      })
      .then((response) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        const itemsFormattedVenda = [] as Array<any>;
        response.data.forEach((venda) => {
          itemsFormattedVenda.push({
            Serie: venda.serie,
            Numero: venda.num,
            Venda: venda.cd,
            Total: formatter.format(venda.total),
          });
        });
      //  setTotalVendas(formatter.format(soma));
        setRowsVenda(itemsFormattedVenda);
      })
      .catch(() => {
        setRowsVenda([]);
      });
  }, [cd_empresa, dt_final, dt_inicial, totalVendas]);

  const abrirFechar = useCallback(
    (venda) => {
      if (vendaClicada == venda) {
        setVendaClicada('');
      } else {
        const vendasProdutos = rowsVendasProdutos.filter(
          (ven: any) => ven.Venda == venda,
        );
        setRowsVendasPorProdutosPorVendas([...vendasProdutos]);
        setVendaClicada(venda);
      }
    },
    [vendaClicada, rowsVendasProdutos],
  );
  return (
    <>
      <Tabela>
        <h1>VALOR TOTAL DE VENDAS :{totalVendas || 'R$:0,00'} </h1>

        {rowsVenda &&
          rowsVenda.map((venda: any) => (
            <>
              <Button
                onClick={() => abrirFechar(venda.Venda)}
                color="white"
                key={venda.Venda}
              >
                {`${venda.Venda} | ${venda.Serie} | ${venda.Numero} | ${venda.Total}`}
              </Button>
              {venda.Venda == vendaClicada && (
                <DataGrid
                  columns={columnsVendasProdutos}
                  rowGetter={(i) => rowsVendasProdutosPorVendas[i]}
                  rowsCount={rowsVendasProdutosPorVendas.length}
                  minHeight={400}
                  emptyRowsView={EmptyRowsView}
                />
              )}
            </>
          ))}
      </Tabela>
      {rowsVenda.length == 0 && (
        <Tabela>
          <DataGrid
            columns={columnsVenda}
            rowGetter={(i) => rowsVenda[i]}
            rowsCount={rowsVenda.length}
            minHeight={400}
            emptyRowsView={EmptyRowsView}
          />
        </Tabela>
      )}
    </>
  );
};

export default Vendas;
